import React from 'react';
import styled from 'styled-components';

export const BaseHeadingStyle = styled.div`
    color: #000;
    font-weight: 700;
    font-family: 'Futura PT', sans-serif;
`;

export const H1 = styled(BaseHeadingStyle)`
    font-size: 70px;
    line-height: 100%;
    margin: 48px 0;
    position: relative;
    left: -3px;
    max-width: 980px;

    @media screen and (max-width: 760px) {
        font-size: 38px;
        margin: 16px 0 24px;
    }
`;
